﻿import React, { useState } from "react";
import { ISubWindowProperties } from "../Components";
import { StaticRepo } from "../../Utilities";
import { Tooltip } from "@material-ui/core";

export interface IToolProps {
    bindToolToFrame: (
        moduleID: number,
        displayName: string,
        toolLookup: string,
        toolUrl: string,
    ) => void;
    moduleID: number;
    rootModuleID: number;
    subSectionID: number;
    displayOrder: number;
    name: string;
    lookupName: string;
    url: string;
    rootUrl: string;
    tooltip: string;
    subWindowProperties?: ISubWindowProperties;
}

export type ImageState = "link" | "fallback";

export const Tool: React.FunctionComponent<IToolProps> = (
    props,
): React.ReactElement => {
    const [imageState, setImageState] = useState<ImageState>(`link`);

    let srcString = `/Images/Icon?icon=${props.moduleID}&folder=Module`;

    if (imageState === `fallback`) {
        srcString = StaticRepo.fallBackToolIcon;
    }

    const bindToolOnClick = (): void => {
        props.bindToolToFrame(
            props.moduleID,
            props.name,
            props.lookupName,
            props.url,
        );
    };

    const onImageLoadError = (): void => {
        setImageState(`fallback`);
    };

    const content: React.ReactElement = (
        <div className={`toolcontainer-tool`} onClick={bindToolOnClick}>
            <img onError={onImageLoadError} src={srcString} />
            <div className={`tool-text`}>{props.name}</div>
        </div>
    );

    return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <React.Fragment>
            {props.tooltip && (
                <Tooltip title={props.tooltip}>{content}</Tooltip>
            )}
            {!props.tooltip && content}
        </React.Fragment>
    );
};
